import { MatPaginatorIntl } from '@angular/material/paginator';

export function getHebrewPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'תוצאות לעמוד';
  paginatorIntl.nextPageLabel = 'לעמוד הבא';
  paginatorIntl.previousPageLabel = 'לעמוד הקודם';
  paginatorIntl.lastPageLabel = 'לעמוד האחרון';
  paginatorIntl.firstPageLabel = 'לעמוד הראשון';

  paginatorIntl.getRangeLabel = (page, pageSize, length) => {
    if (length === 0 || pageSize === 0) return '0 מתוך ' + length;

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return startIndex + 1 + ' - ' + endIndex + ' מתוך ' + length;
  };

  return paginatorIntl;
}
